export class PaginationModel {
    pageNumber :string = "1";
    pageSize :string="10";
    orderBy: string='';
    orderByColumnName: string='';
    approvalStatusID:number=0;
    refTypeID:number=0;
}
